/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import moment from "moment";

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({
  questionnaire,
}) {
  questionnaire = handleGroup({
    questionnaire,
  })

  return questionnaire.map((question) => {
    if (question.idQuestion === 1880 && question.answer) {
      questionnaire = questionnaire.map((qst) => {
        if (qst.idQuestion === 1881 && qst.facilityIndex === question.facilityIndex) {
          const currentDate = moment();
          const inceptionDate = moment(question.answer, 'DD/MM/YYYY');
          const newFieldMinValue = inceptionDate.diff(currentDate, 'days') <= 0 ? inceptionDate.diff(currentDate, 'days') : inceptionDate.diff(currentDate, 'days') + 1;

          qst.behaviorObject.fieldMinValue = newFieldMinValue;
        }

        return qst;
      })
    }

    if (question.idQuestion === 1881 && question.answer) {
      questionnaire = questionnaire.map((qst) => {
        if (qst.idQuestion === 1880 && qst.facilityIndex === question.facilityIndex) {
          const currentDate = moment();
          const expiryDate = moment(question.answer, 'DD/MM/YYYY');
          const newFieldMaxValue =  expiryDate.diff(currentDate, 'days') <= 0 ? expiryDate.diff(currentDate, 'days') : expiryDate.diff(currentDate, 'days') + 1;

          qst.behaviorObject.fieldMaxValue = newFieldMaxValue;
        }

        return qst;
      })
    }

    if (question.idQuestion === 2018 && question.answer) {
      questionnaire = questionnaire.map((qst) => {
        if (qst.idQuestion === 2019 && qst.facilityIndex === question.facilityIndex) {
          const currentDate = moment();
          const paymentDate = moment(question.answer, 'DD/MM/YYYY');
          const newFieldMinValue = paymentDate.diff(currentDate, 'days') <= 0 ? paymentDate.diff(currentDate, 'days') : paymentDate.diff(currentDate, 'days') + 1;

          qst.behaviorObject.fieldMinValue = newFieldMinValue;
        }

        return qst;
      })
    }

    if (question.idQuestion === 2019 && question.answer) {
      questionnaire = questionnaire.map((qst) => {
        if (qst.idQuestion === 2018 && qst.facilityIndex === question.facilityIndex) {
          const currentDate = moment();
          const settlementDate = moment(question.answer, 'DD/MM/YYYY');
          const newFieldMaxValue =  settlementDate.diff(currentDate, 'days') <= 0 ? settlementDate.diff(currentDate, 'days') : settlementDate.diff(currentDate, 'days') + 1;

          qst.behaviorObject.fieldMaxValue = newFieldMaxValue;
        }

        return qst;
      })
    }

    return question;
  })
};

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaireUpdated,
  setFieldValue,
  globalQuestionnaire,
}) {
  try {
    let saveQuestionnaire = false;

    // inception date needs to be smaller or equal to expiry date
    // inception date
    if (question.idQuestion === 1880) {
      saveQuestionnaire = true;

      questionnaireUpdated = questionnaireUpdated.map((qst) => {
        if (qst.idQuestion === 1881 && qst.facilityIndex === question.facilityIndex) {
          const currentDate = moment();
          const inceptionDate = moment(value, 'DD/MM/YYYY');
          const newFieldMinValue = inceptionDate.diff(currentDate, 'days') <= 0 ? inceptionDate.diff(currentDate, 'days') : inceptionDate.diff(currentDate, 'days') + 1;

          qst.behaviorObject.fieldMinValue = newFieldMinValue;
        }

        return qst;
      })

    }

    // settlement date
    if (question.idQuestion === 1881) {
      saveQuestionnaire = true;

      questionnaireUpdated = questionnaireUpdated.map((qst) => {
        if (qst.idQuestion === 1880 && qst.facilityIndex === question.facilityIndex) {
          const currentDate = moment();
          const expiryDate = moment(value, 'DD/MM/YYYY');
          const newFieldMaxValue =  expiryDate.diff(currentDate, 'days') <= 0 ? expiryDate.diff(currentDate, 'days') : expiryDate.diff(currentDate, 'days') + 1;

          qst.behaviorObject.fieldMaxValue = newFieldMaxValue;
        }

        return qst;
      })
    }

    // payment date needs to be smaller or equal to settlement date
    // payment date
    if (question.idQuestion === 2018) {
      saveQuestionnaire = true;

      questionnaireUpdated = questionnaireUpdated.map((qst) => {
        if (qst.idQuestion === 2019 && qst.facilityIndex === question.facilityIndex) {
          const currentDate = moment();
          const paymentDate = moment(value, 'DD/MM/YYYY');
          const newFieldMinValue = paymentDate.diff(currentDate, 'days') <= 0 ? paymentDate.diff(currentDate, 'days') : paymentDate.diff(currentDate, 'days') + 1;

          qst.behaviorObject.fieldMinValue = newFieldMinValue;
        }

        return qst;
      })

    }

    // settlement date
    if (question.idQuestion === 2019) {
      saveQuestionnaire = true;

      questionnaireUpdated = questionnaireUpdated.map((qst) => {
        if (qst.idQuestion === 2018 && qst.facilityIndex === question.facilityIndex) {
          const currentDate = moment();
          const settlementDate = moment(value, 'DD/MM/YYYY');
          const newFieldMaxValue =  settlementDate.diff(currentDate, 'days') <= 0 ? settlementDate.diff(currentDate, 'days') : settlementDate.diff(currentDate, 'days') + 1;

          qst.behaviorObject.fieldMaxValue = newFieldMaxValue;
        }

        return qst;
      })
    }

    if (saveQuestionnaire) setQuestionnaireUpdated(questionnaireUpdated);

  } catch (e) {
    console.log('RISK_DETAILS_FACILITY - handleQuestionChange - error', e)
  }
};

function handleQuestionBlur({
  question,
  value,
  setFieldValue,
  formikRef,
  obligorGroup,
  setObligorGroup,
  index,
  values,
  setMaxValuePerc,
  mask,
  maskPercentage,
}) {
  try {

  } catch (e) {
    console.log("RISK_DETAILS_FACILITY - handleQuestionBlur error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    questionnaire = questionnaire.map(question => {

      return question;
    })

    setQuestionnaire(questionnaire);
  } catch (e) {
    console.log('RISK_DETAILS_FACILITY - handleRequestSerproCnpj - error', e)
  }
};

function handleGroup({
  questionnaire,
}) {
  const facilityNameQuestionnaireAnswers = questionnaire.filter((question) => question.idQuestion === 123);

  const inceptionDateQuestionnaireAnswer = questionnaire.filter((question) => question.idQuestion === 1880);
  const expireDateQuestionnaireAnswer = questionnaire.filter((question) => question.idQuestion === 1881);
  const yearAccountQuestionnaireAnswer = questionnaire.filter((question) => question.idQuestion === 2013);
  const paymentDateQuestionnaireAnswer = questionnaire.filter((question) => question.idQuestion === 2018);
  const settlementDateQuestionnaireAnswer = questionnaire.filter((question) => question.idQuestion === 2019);
  const shortDescriptionQuestionnaireAnswer = questionnaire.filter((question) => question.idQuestion === 128);

  const newInceptionDateQuestions = [];
  const newExpireDateQuestions = [];
  const newYearAccountQuestions = [];
  const newShortDescriptionQuestions = [];
  const newPaymentDateQuestions = [];
  const newSettlementDateQuestions = [];

  if (
    facilityNameQuestionnaireAnswers?.length === inceptionDateQuestionnaireAnswer?.length &&
    facilityNameQuestionnaireAnswers?.length === expireDateQuestionnaireAnswer?.length &&
    facilityNameQuestionnaireAnswers?.length === yearAccountQuestionnaireAnswer?.length &&
    facilityNameQuestionnaireAnswers?.length === paymentDateQuestionnaireAnswer?.length &&
    facilityNameQuestionnaireAnswers?.length === settlementDateQuestionnaireAnswer?.length &&
    facilityNameQuestionnaireAnswers?.length === shortDescriptionQuestionnaireAnswer?.length
  ) {

    facilityNameQuestionnaireAnswers.forEach((question, index) => {
      newInceptionDateQuestions.push({
        ...inceptionDateQuestionnaireAnswer[index],
        facilityIndex: index,
        dsQuestion: `${question.answer} - ${inceptionDateQuestionnaireAnswer[index].dsQuestion}`,
        sequenceQuestion: 5 * (index + 1) + 80 + index
      });

      newExpireDateQuestions.push({
        ...expireDateQuestionnaireAnswer[index],
        facilityIndex: index,
        dsQuestion: `${question.answer} - ${expireDateQuestionnaireAnswer[index].dsQuestion}`,
        sequenceQuestion: 5 * (index + 1) + 81 + index
      })

      newYearAccountQuestions.push({
        ...yearAccountQuestionnaireAnswer[index],
        facilityIndex: index,
        dsQuestion: `${question.answer} - ${yearAccountQuestionnaireAnswer[index].dsQuestion}`,
        sequenceQuestion: 5 * (index + 1) + 82 + index,
        fieldMask: {
          ...yearAccountQuestionnaireAnswer[index].fieldMask,
          validate: function (value) {
            return value.length === 4;
          }
        }
      })

      newPaymentDateQuestions.push({
        ...paymentDateQuestionnaireAnswer[index],
        facilityIndex: index,
        dsQuestion: `${question.answer} - ${paymentDateQuestionnaireAnswer[index].dsQuestion}`,
        sequenceQuestion: 5 * (index + 1) + 83 + index,
      })

      newSettlementDateQuestions.push({
        ...settlementDateQuestionnaireAnswer[index],
        facilityIndex: index,
        dsQuestion: `${question.answer} - ${settlementDateQuestionnaireAnswer[index].dsQuestion}`,
        sequenceQuestion: 5 * (index + 1) + 84 + index,
      })

      newShortDescriptionQuestions.push({
        ...shortDescriptionQuestionnaireAnswer[index],
        behaviorObject: {
          ...shortDescriptionQuestionnaireAnswer[index].behaviorObject,
          sectionName: 'RISK_DETAILS_FACILITY',
        },
        dsQuestion: `${question.answer} - ${shortDescriptionQuestionnaireAnswer[index].dsQuestion}`,
        sequenceQuestion: 5 * (index + 1) + 85 + index,
      })
    });
  } else {

    const cloneInceptionDateQuestionnaireAnswer = JSON.parse(JSON.stringify(inceptionDateQuestionnaireAnswer));
    const cloneExpireDateQuestionnaireAnswer = JSON.parse(JSON.stringify(expireDateQuestionnaireAnswer));
    const cloneYearAccountQuestionnaireAnswer = JSON.parse(JSON.stringify(yearAccountQuestionnaireAnswer));
    const clonePaymentDateQuestionnaireAnswer = JSON.parse(JSON.stringify(paymentDateQuestionnaireAnswer));
    const cloneSettlementDateQuestionnaireAnswer = JSON.parse(JSON.stringify(settlementDateQuestionnaireAnswer));

    facilityNameQuestionnaireAnswers.forEach((question, index) => {
      newInceptionDateQuestions.push({
        ...(cloneInceptionDateQuestionnaireAnswer[index] ? cloneInceptionDateQuestionnaireAnswer[index] : cloneInceptionDateQuestionnaireAnswer[0]),
        facilityIndex: index,
        answer: cloneInceptionDateQuestionnaireAnswer[index] ? cloneInceptionDateQuestionnaireAnswer[index].answer : null,
        answerJson: cloneInceptionDateQuestionnaireAnswer[index] ? cloneInceptionDateQuestionnaireAnswer[index].answerJson : null,
        idAnswerOption: cloneInceptionDateQuestionnaireAnswer[index] ? cloneInceptionDateQuestionnaireAnswer[index].idAnswerOptions : null,
        idQuestionnaireAnswers: cloneInceptionDateQuestionnaireAnswer[index] ? cloneInceptionDateQuestionnaireAnswer[index].idQuestionnaireAnswers : null,
        dsQuestion: `${question.answer} - ${cloneInceptionDateQuestionnaireAnswer[0].dsQuestion}`,
        sequenceQuestion: 5 * (index + 1) + 80 + index
      });

      newExpireDateQuestions.push({
        ...(cloneExpireDateQuestionnaireAnswer[index] ? cloneExpireDateQuestionnaireAnswer[index] : cloneExpireDateQuestionnaireAnswer[0]),
        facilityIndex: index,
        answer: cloneExpireDateQuestionnaireAnswer[index] ? cloneExpireDateQuestionnaireAnswer[index].answer : null,
        answerJson: cloneExpireDateQuestionnaireAnswer[index] ? cloneExpireDateQuestionnaireAnswer[index].answerJson : null,
        idAnswerOption: cloneExpireDateQuestionnaireAnswer[index] ? cloneExpireDateQuestionnaireAnswer[index].idAnswerOptions : null,
        idQuestionnaireAnswers: cloneExpireDateQuestionnaireAnswer[index] ? cloneExpireDateQuestionnaireAnswer[index].idQuestionnaireAnswers : null,
        dsQuestion: `${question.answer} - ${cloneExpireDateQuestionnaireAnswer[0].dsQuestion}`,
        sequenceQuestion: 5 * (index + 1) + 81 + index
      })

      newYearAccountQuestions.push({
        ...(cloneYearAccountQuestionnaireAnswer[index] ? cloneYearAccountQuestionnaireAnswer[index] : cloneYearAccountQuestionnaireAnswer[0]),
        facilityIndex: index,
        answer: cloneYearAccountQuestionnaireAnswer[index] ? cloneYearAccountQuestionnaireAnswer[index].answer : null,
        answerJson: cloneYearAccountQuestionnaireAnswer[index] ? cloneYearAccountQuestionnaireAnswer[index].answerJson : null,
        idAnswerOption: cloneYearAccountQuestionnaireAnswer[index] ? cloneYearAccountQuestionnaireAnswer[index].idAnswerOptions : null,
        idQuestionnaireAnswers: cloneYearAccountQuestionnaireAnswer[index] ? cloneYearAccountQuestionnaireAnswer[index].idQuestionnaireAnswers : null,
        dsQuestion: `${question.answer} - ${cloneYearAccountQuestionnaireAnswer[0].dsQuestion}`,
        sequenceQuestion: 5 * (index + 1) + 82 + index,
        fieldMask: {
          ...cloneYearAccountQuestionnaireAnswer[0].fieldMask,
          validate: function (value) {
            return value.length === 4;
          }
        }
      })

      newPaymentDateQuestions.push({
        ...(clonePaymentDateQuestionnaireAnswer[index] ? clonePaymentDateQuestionnaireAnswer[index] : clonePaymentDateQuestionnaireAnswer[0]),
        facilityIndex: index,
        answer: clonePaymentDateQuestionnaireAnswer[index] ? clonePaymentDateQuestionnaireAnswer[index].answer : null,
        answerJson: clonePaymentDateQuestionnaireAnswer[index] ? clonePaymentDateQuestionnaireAnswer[index].answerJson : null,
        idAnswerOption: clonePaymentDateQuestionnaireAnswer[index] ? clonePaymentDateQuestionnaireAnswer[index].idAnswerOptions : null,
        idQuestionnaireAnswers: clonePaymentDateQuestionnaireAnswer[index] ? clonePaymentDateQuestionnaireAnswer[index].idQuestionnaireAnswers : null,
        dsQuestion: `${question.answer} - ${clonePaymentDateQuestionnaireAnswer[0].dsQuestion}`,
        sequenceQuestion: 5 * (index + 1) + 83 + index,
      })

      newSettlementDateQuestions.push({
        ...(cloneSettlementDateQuestionnaireAnswer[index] ? cloneSettlementDateQuestionnaireAnswer[index] : cloneSettlementDateQuestionnaireAnswer[0]),
        facilityIndex: index,
        answer: cloneSettlementDateQuestionnaireAnswer[index] ? cloneSettlementDateQuestionnaireAnswer[index].answer : null,
        answerJson: cloneSettlementDateQuestionnaireAnswer[index] ? cloneSettlementDateQuestionnaireAnswer[index].answerJson : null,
        idAnswerOption: cloneSettlementDateQuestionnaireAnswer[index] ? cloneSettlementDateQuestionnaireAnswer[index].idAnswerOptions : null,
        idQuestionnaireAnswers: cloneSettlementDateQuestionnaireAnswer[index] ? cloneSettlementDateQuestionnaireAnswer[index].idQuestionnaireAnswers : null,
        dsQuestion: `${question.answer} - ${cloneSettlementDateQuestionnaireAnswer[0].dsQuestion}`,
        sequenceQuestion: 5 * (index + 1) + 84 + index,
      })

      newShortDescriptionQuestions.push({
        ...shortDescriptionQuestionnaireAnswer[index],
        behaviorObject: {
          ...shortDescriptionQuestionnaireAnswer[index].behaviorObject,
          sectionName: 'RISK_DETAILS_FACILITY',
        },
        dsQuestion: `${question.answer} - ${shortDescriptionQuestionnaireAnswer[index].dsQuestion}`,
        sequenceQuestion: 5 * (index + 1) + 85 + index,
      })
    });
  }

  const sortedFacilityQuestions = [
    ...newInceptionDateQuestions,
    ...newExpireDateQuestions,
    ...newYearAccountQuestions,
    ...newPaymentDateQuestions,
    ...newSettlementDateQuestions,
    ...newShortDescriptionQuestions
  ].sort((a, b) => a.facilityIndex - b.facilityIndex).sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

  questionnaire = questionnaire.filter((question) => ![128, 1880, 1881, 2013, 2018, 2019].includes(question.idQuestion));

  questionnaire = [...questionnaire, ...sortedFacilityQuestions];

  return questionnaire;
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleQuestionBlur,
  handleRequestSerproCnpj,
};

export { events };